import { useEffect, useState } from "react";
import { collection, onSnapshot, orderBy, query } from "firebase/firestore";
import { database } from "../../database/firebase";

const useMessages = (roomId) => {
  const [messageData, setMessageData] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const getMessageData = async () => {
      try {
        setLoading(true);
        await onSnapshot(
          query(
            collection(database, "userRooms", roomId, "messages"),
            orderBy("timestamp", "asc")
          ),
          (snapshot) => {
            setMessageData(
              snapshot.docs.map((doc) => ({
                data: doc.data(),
                id: doc.id,
              }))
            );
          }
        );
        setLoading(false);
      } catch (error) {}
    };
    getMessageData();
  }, [roomId]);

  return {
    messageData,
    loading,
  };
};

export default useMessages;
